import { FC, InputHTMLAttributes } from "react";
import { Box, Flex } from "@otrium/core";
import {
  Check,
  CheckboxLabel,
  ColorBox,
  MobileCheckboxLabel,
  StyledWrapper,
} from "./ColorFilterCheckbox.styled";
import isLightColor from "src/utils/isLightColor";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  icon?: string | undefined | null;
  hex?: string | undefined | null;
  name: string;
  id?: string;
}

const ColorFilterCheckbox: FC<Props> = ({
  id,
  icon,
  name,
  hex,
  checked,
  ...inputProps
}) => {
  const baseBoxProps = {
    position: "relative",
    borderRadius: "20px",
    height: "40px",
    width: "40px",
    border: `${id === "WHITE" ? "1px solid #999" : "none"}`,
  };
  const colorProps = { ...baseBoxProps, backgroundColor: hex as string };
  const bgIconProps = {
    ...baseBoxProps,
    backgroundPosition: "center",
    backgroundSize: "80px",
    backgroundImage: `url(${icon})`,
    color: "White",
    bg: "transparent",
  };
  const boxProps = !hex && icon ? bgIconProps : colorProps;
  const isLight = !!(hex && isLightColor(hex));

  return (
    <StyledWrapper>
      <Flex mb={1}>
        <MobileCheckboxLabel>
          <input type="checkbox" checked={checked} {...inputProps} />
          <Flex mr={2} sx={{ ...boxProps }}>
            {checked && <Check stroke={isLight ? "#000" : "#FFF"} />}
          </Flex>
          {name}
        </MobileCheckboxLabel>
      </Flex>
    </StyledWrapper>
  );
};

export default ColorFilterCheckbox;

export const ColorFilterCheckboxOzon: FC<Props> = ({
  id,
  icon,
  name,
  hex,
  ...inputProps
}) => {
  const { checked } = inputProps;

  const baseBoxProps = {
    height: checked ? "12px" : "18px",
    width: checked ? "12px" : "18px",
    borderRadius: checked ? "2px" : "1px",
    border: `${id === "WHITE" ? "1px solid #999" : "none"}`,
  };
  const colorProps = { ...baseBoxProps, backgroundColor: hex };
  const bgIconProps = {
    ...baseBoxProps,
    backgroundPosition: "center",
    backgroundSize: "34px",
    backgroundImage: `url(${icon})`,
    color: "White",
    bg: "transparent",
  };
  const colorBoxProps = !hex && icon ? bgIconProps : colorProps;
  return (
    <StyledWrapper>
      <Flex mb={1}>
        <CheckboxLabel>
          <input type="checkbox" {...inputProps} />
          <ColorBox variant="centered" mr={2} active={checked}>
            <Box sx={{ ...colorBoxProps }} />
          </ColorBox>
          {name}
        </CheckboxLabel>
      </Flex>
    </StyledWrapper>
  );
};
